import { createRouter, createWebHistory } from 'vue-router';
import paths from './path';
import { BasePaths } from '@/lib/const';
import { keepAlive } from '@/apis/common/keepAlive';
import { HttpStatus } from '@/lib/const';

// 接続先情報の取得
const BasePath = BasePaths;
function route(path, view, name, meta, props) {
  return {
    name: name || view,
    path,
    meta,
    props,
    component: resovle =>
      import(`@/pages/${BasePath}/${view}.vue`).then(resovle),
  };
}

const router = createRouter({
  history: createWebHistory(),
  routes: paths
    .map(path => route(path.path, path.view, path.name, path.meta, path.props))
    .concat([{ path: '/:pathMatch(.*)*', redirect: '/' }]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash };
    }
    return { top: 0 };
  },
});

// デプロイ後の旧バージョン検知（画面遷移後に非同期でチェック、ナビゲーションをブロックしない）
let initialVersion = null;
let versionOutdated = false;
router.afterEach(async () => {
  if (versionOutdated) return;
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    const { version } = await res.json();
    if (initialVersion === null) {
      initialVersion = version;
    } else if (initialVersion !== version) {
      versionOutdated = true;
    }
  } catch {
    // version.json が取得できない場合は無視
  }
});

router.beforeEach(async (to, from, next) => {
  if (versionOutdated) {
    window.location.href = to.fullPath;
    return;
  }
  const toPath = to.matched[0].path ? to.matched[0].path : to.path;

  const httpStatus = await keepAlive().catch(err => {
    return err;
  });
  if (to.name === 'Maintenance') {
    if (httpStatus && httpStatus !== HttpStatus.Maintenance) {
      // 通常時のメンテナンス画面へのアクセスはホーム画面にリダイレクト
      return next('/');
    }
  } else {
    if (httpStatus === HttpStatus.Maintenance) {
      // メンテナンス時はメンテナンス画面に遷移
      return next('/maintenance');
    }
  }
  next();
});

export default router;
